// extracted by mini-css-extract-plugin
module.exports = {"siteFooter":"footer-module--siteFooter--2qdyC","container":"footer-module--container--2Y5FL"};